<template>
  <transition>
    <header v-if="!raceDataIsFetching" class="race-header">
      <div class="race-header__top">
        <router-link class="race-header__logo-link" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" class="race-header__logo" tabindex="-1" viewBox="0 0 139.01 63.64" v-bind:svg-inline="''" v-bind:class="'race-header__logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#fff" d="M69.893 18.412L56.428 45.075 47.744 45l9.965-19.33-4.02.062 4.073-7.36s11.414.04 12.681.04m4.144-2.816l-18.26.01-6.692 12.317h4.147l-9.538 19.336h14.175zm-40.15 2.098c3.257 0 7.411.095 12.792.131l-2.536 5.17h-14.85L26.52 30.1h12.997l-2.601 5.169h-13.55l-4.435 9.69h-8.038c13.737-24.804 6.99-27.265 23.543-27.265m0-2.184c-6.12 0-9.713.343-12.398 2.192-2.536 1.754-3.66 4.499-5.512 9.042-1.637 4.026-3.892 9.544-8.216 17.356l-1.684 3.05h14.289c1.48-3.23 2.957-6.46 4.435-9.69h13.484c1.753-3.476 3.094-6.144 4.8-9.537h-13.1l1.282-2.737H46.64c1.707-3.468 3.01-6.128 4.67-9.508l-4.034-.03c-4.391-.012-8.664-.135-12.838-.138z" class="st1"/><path fill="none" stroke="#ed1c24" stroke-linecap="square" stroke-miterlimit="10" stroke-width="3" d="M129.39 28.46c-36.89-.74-36.4 3.64-33.49 4.26 29.05 6.27 26.13 18.21 5.48 22-2.8.51-37.2 8.36-99.09 7.32l4.18-9.41c58.26-.28 87.41-3.14 89.29-8.36 1.89-5.27-23.45-7.43-23.29-12.55.18-5.66 29.54-13.23 63.64-12.55l-6.72 9.29z"/></svg>
        </router-link>
        <div class="race-header__info">
          <template v-if="$navigatorOnline">
            <button
              :class="['race-header__race-btn', { active: raceActive }]"
              v-on:click="activateRaceOverlay(true)"
              ref="heading"
            >
              <h1 class="race-header__race">{{ race.raceName }}</h1>
            </button>
            <span class="race-header__circuit">{{
              race.Circuit.circuitName
            }}</span>
          </template>
          <template v-else>
            <span
              class="race-header__race-btn race-header__race-btn--offline"
              ref="heading"
            >
              <h1 class="race-header__race">{{ race.raceName }}</h1>
            </span>
            <span class="race-header__circuit">{{
              race.Circuit.circuitName
            }}</span>
          </template>

          <span class="race-header__round-and-date">
            <span class="race-header__round"
              >Round {{ race.round }},&nbsp;</span
            >
            <button
              v-if="$navigatorOnline"
              :class="['race-header__year-btn', { active: yearActive }]"
              v-html="race.season"
              v-on:click="activateYearOverlay"
            ></button>
            <span
              v-else
              class="race-header__year-btn race-header__year-btn--offline"
              v-html="race.season"
            ></span>
            <span
              class="race-header__date"
              v-html="seperateDate(race.date)"
            ></span>
          </span>
        </div>
      </div>
      <RaceSelect
        v-if="!latestRaceDataFetching && $navigatorOnline"
        :latestRaceData="latestRaceData"
        :seasons="seasons"
        :race="race"
      ></RaceSelect>
    </header>
  </transition>
</template>

<script>
import RaceSelect from '@/components/RaceSelect'
import EventBus from '@/event-bus/event-bus.js'

export default {
  name: 'race-header',
  components: {
    RaceSelect
  },
  props: {
    race: [Object, Boolean],
    raceDataIsFetching: Boolean,
    seasons: Array,
    latestRaceData: [Object, Boolean],
    latestRaceDataFetching: [Boolean]
  },
  data () {
    return {
      headingActive: true,
      yearActive: false,
      raceActive: false
    }
  },
  mounted () {
    // Emitted from raceSelect.vue
    EventBus.$on('activateRaceOverlay', () => {
      this.activateRaceOverlay()
    })
  },
  methods: {
    seperateDate (e) {
      // if (this.raceDataIsFetching) {
      return e.split(/[0-9]{4}/).pop()
      // }
    },
    activateYearOverlay () {
      this.raceActive = false
      !this.yearActive ? this.yearActive = true : this.yearActive = false

      // Emitted to RaceSelect.vue
      EventBus.$emit('raceSelectYearState')
    },
    activateRaceOverlay (bool) {
      this.yearActive = false
      !this.raceActive ? this.raceActive = true : this.raceActive = false

      if (bool) {
        // Emitted to RaceSelect.vue
        EventBus.$emit('raceSelectRaceState', true)
      } else {
        EventBus.$emit('raceSelectRaceState', false)
      }
    }
  }
}
</script>
